// Which --ml-cat-* tint a category wears (tokens.css). Category colour is
// decorative and appears only as the 8 px dot, the check ring, the chip icon
// and the editor pill (ux/01 Craft rules), never on a row background.
//
// Seeded categories keep their slot's colour whatever they're called now
// (English, legacy Swedish, or renamed but still carrying the seeded icon);
// a category the household made itself takes the slot colour its sort order
// lands on. The watch repeats this in watch/source/Theme.mc.

import type { Category } from './supabase'
import { slotIndexOf } from './autocategory'

export const TINTS = ['produce', 'dairy', 'bakery', 'pantry', 'frozen', 'household'] as const
export type Tint = (typeof TINTS)[number] | 'other'

export function tintOf(category: Pick<Category, 'name' | 'icon' | 'sort_order'> | null | undefined): Tint {
  if (!category) return 'other'
  const slot = slotIndexOf(category)
  if (slot !== null) return TINTS[slot]
  const n = TINTS.length
  return TINTS[((category.sort_order % n) + n) % n]
}

/** The CSS custom property for a category's tint. */
export const tintVar = (category: Pick<Category, 'name' | 'icon' | 'sort_order'> | null | undefined) =>
  `var(--ml-cat-${tintOf(category)})`
